import React from "react";
import { Box, Typography } from "@mui/material";

export default function Loader({ message = "Loading..." }) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 9999,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box
          sx={{
            width: "8px",
            height: "30px",
            backgroundColor: "#5c42f4",
            borderRadius: "4px",
            mx: 0.5,
            animation: "bounce 1.4s infinite ease-in-out",
            animationDelay: "-0.32s",
            "@keyframes bounce": {
              "0%, 80%, 100%": { transform: "scaleY(0.4)" },
              "40%": { transform: "scaleY(1.0)" },
            },
          }}
        />
        <Box
          sx={{
            width: "8px",
            height: "40px",
            backgroundColor: "#5c42f4",
            borderRadius: "4px",
            mx: 0.5,
            animation: "bounce 1.4s infinite ease-in-out",
            animationDelay: "-0.16s",
            "@keyframes bounce": {
              "0%, 80%, 100%": { transform: "scaleY(0.4)" },
              "40%": { transform: "scaleY(1.0)" },
            },
          }}
        />
        <Box
          sx={{
            width: "8px",
            height: "30px",
            backgroundColor: "#5c42f4",
            borderRadius: "4px",
            mx: 0.5,
            animation: "bounce 1.4s infinite ease-in-out",
            "@keyframes bounce": {
              "0%, 80%, 100%": { transform: "scaleY(0.4)" },
              "40%": { transform: "scaleY(1.0)" },
            },
          }}
        />
      </Box>
    </Box>
  );
}
